export enum INotificationType {
    Error,
    Warning,
    Unauthorized,
    Forbidden,
    Success,
    Info,
    Loading
}